<template>
  <el-row class="submission-component__buttons">
    <el-col class="submission-component__buttons__left">
      <el-button
        :disabled="!hasPrev"
        @click="previousSection"
      >
      <i class="el-icon-arrow-left"></i>
      <span class="button-text">Previous</span>
      </el-button>

      <el-button
        :disabled="!hasNext"
        @click="nextSection"
      >
      <span class="button-text">Next</span>
      <i class="el-icon-arrow-right"></i>
      </el-button>
    </el-col>
    <el-col
      v-if="editable"
      class="submission-component__buttons__right">
      <SaveIndicator class="submission-component__save-indicator"/>
      <el-button
        :disabled="!(submittable && seenLastPage)"
        @click="finalize"
        type="primary"
      >
      <span>Submit</span>
      </el-button>
    </el-col>
  </el-row>
</template>

<script>
import SUBMISSION_STATUS from '@/assets/data/viddsee/submissionStatus';
import SaveIndicator from '@/components/Utilities/SaveIndicator';
import pageNavigationMixin from '../Mixins/pageNavigationMixin';

export default {
  mixins: [
    pageNavigationMixin,
  ],
  components: {
    SaveIndicator,
  },
  props: {
    prev: {
      type: Function,
      default: () => null,
    },
    next: {
      type: Function,
      default: () => null,
    },
    submittable: {
      type: Boolean,
      default: false,
    },
    seen: {
      type: Array,
    },
  },
  computed: {
    editable() {
      return SUBMISSION_STATUS.getInfo(
        this.$store.state.submission[this.$route.params.videoId].status
      ).editable;
    },
    seenLastPage() {
      return this.seen[this.children.length - 1];
    },
  },
  methods: {
    finalize() {
      this.$emit('submit');
    },
  },
};
</script>

<style lang="scss">
.submission-component__buttons {
  height: 100%;
  display: flex;
  align-items: center;
}

.submission-component__buttons__right,
.submission-component__buttons__left {
  white-space: nowrap;
  .button-text {
    display: none;
    @include breakpoint-up(sm) {
      display: inline;
    }
  }
}
.submission-component__buttons__right {
  text-align: right;
}

.submission-component__save-indicator {
  display: inline-block;
  pointer-events: none;
  opacity: 0.5;

  span {
    display: none;
    @include breakpoint-up(sm) {
      display: inline;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Submission/Shared/NavigationButtons.vue